<template>
  <div>
    <div>
      <span class="has-text-default is-italic"> N° {{societe.codeSociete }} </span> <br>
      <p class="has-text-weight-semibold">
        {{ societe.libelle }}
      </p>
    </div>
    <div class="mgt-10px">
      <b-field :label="$t('detailSociete.fusionSociete.adresse')"
        custom-class="has-text-weight-normal is-marginless">
        <span class="has-text-weight-bold">
          {{ importedFunction.adressFullStringGetter(societe.adresse) }}
        </span>
      </b-field>
    </div>
  </div>
</template>

<script>
import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export default {
  name: 'SocieteInfo',
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      importedFunction: {
        adressFullStringGetter,
      },
    };
  },
};
</script>
